// @flow

import styled from '@emotion/styled'

export const FiltersLayout = styled.div`
  display: grid;
  grid-gap: 1rem 0;
`
